import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { closeSnackbar, toggleErrorsDialog } from '../actions/view'
import { themeObj } from 'components/withRoot'
import CloseIcon from '@material-ui/icons/Close'
import { Snackbar, IconButton, withStyles } from '@material-ui/core'
import Button from 'components/theme/Button'
import { refreshToken } from 'actions/auth'
import { openPaymentsModal } from 'actions/paymentsManager'
import { messageMap as messageMapObj } from 'reducers/snackbar'
import { toggleManagePhonesModal } from 'actions/tasks'
import { Link } from 'react-router-dom'

const urlParams = new URLSearchParams(window.location.search)
const jwtToken = urlParams.get('jwtToken')

const mapStateToProps = (state) => ({
	snackbar: state.snackbar[0] || { type: null, message: '', details: false },
})

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			closeSnackbar,
			toggleErrorsDialog,
			refreshToken,
			openPaymentsModal,
			toggleManagePhonesModal,
		},
		dispatch,
	)

const styles = (theme) => ({
	success: { backgroundColor: theme.palette.green },
	error: { backgroundColor: theme.palette.red },
	live: { backgroundColor: theme.palette.green },
	paused: { backgroundColor: themeObj.palette.orange },
	default: { backgroundColor: themeObj.palette.pink },
})

// const messageMap = {
// 'This cannot be deleted.': true,
// 'Please enter a payment method.': true,
// 'Your subscription has been charged successfully!': true,
// 'Your subscription is in trial.': true,
// 'Your trial has ended. Please choose a subscription.': true,
// 'Your subscription has been cancelled. Please choose a subscription.': true,
// 'Your payment is past due. Please check your subscription settings.': true,
// 'Your subscription has been charged unsuccessfully.': true,
// 'Your subscription is expired. Please choose a subscription.': true,
// }

const messageMap = Object.values(messageMapObj).reduce((acc, el) => {
	acc[el] = true
	return acc
}, {})

// console.log(messageMap)

class Snack extends Component {
	state = { open: false }

	componentDidUpdate(prevProps) {
		// console.log('<Snack /> componentDidUpdate')
		if (
			prevProps.snackbar.message !== this.props.snackbar.message &&
			this.props.snackbar.message
		) {
			// console.log(
			//   'if (prevProps.snackbar.message !== this.props.snackbar.message) {',
			// )

			if (this.props.snackbar.message === 'Token is expired') {
				// console.log("this.props.snackbar.message === 'Token is expired'")
				this.props.closeSnackbar()
				if (jwtToken) {
					// console.log('if (jwtToken)')
					if (window.ReactNativeWebView) {
						// console.log('window.ReactNativeWebView')
						if (window.ReactNativeWebView.postMessage) {
							// console.log('window.ReactNativeWebView.postMessage')
							window.ReactNativeWebView.postMessage('refreshToken')
						}
					}
				} else {
					this.props.refreshToken()
				}
			} else {
				Promise.resolve(this.setState({ open: false })).then(() =>
					setTimeout(() => this.setState({ open: true }), 1000),
				)
			}

			if (messageMap[this.props.snackbar.message]) {
				this.props.openPaymentsModal(true)
			}
		}
	}

	handleClose = () => {
		this.setState({ open: false })
		this.props.closeSnackbar()
	}

	render() {
		const { snackbar, classes } = this.props

		return snackbar && snackbar.type === 'error' ? (
			<Snackbar
				anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
				open={this.state.open}
				onClose={this.handleClose}
				ContentProps={{
					'aria-describedby': 'message-id',
					className:
						(snackbar && snackbar.type && classes[snackbar.type]) ||
						classes.default,
				}}
				message={
					<span
						id="message-id"
						style={{
							color: '#fff',
						}}
					>
						{snackbar.message}
					</span>
				}
				// TODO: add a way to dynamically give a function in the reducer
				action={
					snackbar.action
						? [
								<Button
									style={{ color: '#fff' }}
									onClick={() =>
										this.props[snackbar.action]
											? this.props[snackbar.action]()
											: console.log('no action')
									}
									component={
										snackbar.action === 'link'
											? (props) => <Link to={snackbar.to} {...props} />
											: undefined
									}
								>
									{snackbar.actionMessage || 'Click here'}
								</Button>,
								<IconButton
									key="close"
									aria-label="Close"
									color="inherit"
									onClick={this.handleClose}
								>
									<CloseIcon />
								</IconButton>,
						  ]
						: snackbar.details
						? [
								<Button
									style={{ color: '#fff' }}
									onClick={() => this.props.toggleErrorsDialog(true)}
								>
									View Details
								</Button>,
								<IconButton
									key="close"
									aria-label="Close"
									color="inherit"
									onClick={this.handleClose}
								>
									<CloseIcon />
								</IconButton>,
						  ]
						: [
								<IconButton
									key="close"
									aria-label="Close"
									color="inherit"
									onClick={this.handleClose}
								>
									<CloseIcon />
								</IconButton>,
						  ]
				}
			/>
		) : (
			<Snackbar
				anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
				open={this.state.open}
				onClose={this.handleClose}
				ContentProps={{
					'aria-describedby': 'message-id',
					className:
						(snackbar && snackbar.type && classes[snackbar.type]) ||
						classes.default,
				}}
				message={
					<span
						id="message-id"
						style={{
							color: '#fff',
						}}
					>
						{snackbar.message}
					</span>
				}
				autoHideDuration={5000}
			/>
		)
	}
}

export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(withStyles(styles)(Snack))
